import { z } from 'zod';
/** Roles a person can hold inside one tenant. Attribute rules (product, customer) narrow them further. */
export const ROLES = [
    'tenant_admin',
    'config_editor',
    'config_approver',
    'underwriter',
    'broker',
    'sme_owner',
    'sme_member',
    'auditor',
];
export const Role = z.enum(ROLES);
//# sourceMappingURL=roles.js.map